import { render, staticRenderFns } from "./currency.vue?vue&type=template&id=4ea1df73"
import script from "./currency.vue?vue&type=script&lang=js"
export * from "./currency.vue?vue&type=script&lang=js"
import style0 from "./currency.vue?vue&type=style&index=0&id=4ea1df73&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports